///
/// EarthBrowser
///
/// Migration v47 to v48: Add story cloud dataset references
/// Created by Matt Giger on 9/24/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v47 to v48
 *
 * Changes:
 * - Each story gains a `datasets` pool (cloud dataset references that
 *   stops mount during playback via `datasetIds`). Existing stories get
 *   an empty pool.
 */
export function migrateV47toV48(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object" || !s.stories) return state

	const storiesState = s.stories as { stories?: Record<string, Record<string, unknown> | null> }
	if (!storiesState.stories || typeof storiesState.stories !== "object") return state

	const stories: Record<string, unknown> = {}
	for (const [id, story] of Object.entries(storiesState.stories)) {
		stories[id] = story && typeof story === "object" && !story.datasets
			? { ...story, datasets: [] }
			: story
	}

	return { ...s, stories: { ...storiesState, stories } }
}
